/*
 * サブシステム名：マスタ管理
 * 機能名：権限設定一覧
 */
import DdCustomButton from '@/components/DdCustomButton'

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import filter from '@/rahmen/utils/filters'

const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')

const DdDataTable = () => import('@/components/DdDataTable')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstKengenList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      kengenGroupCd: '',
      kengenGroupNm: ''
    },
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdDataTable,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      menuList: 'DDMasters/msysMenu',
      menuDetailList: 'DDMasters/msysMenuDetail',
      kinoList: 'DDMasters/msysKino',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredMenuList () {
      const result = this.menuList.map((m) => {
        m.listDisplay = this.menuDetailList.filter((d) => {
          return d.mstMenuId === m.id
        }).map((d) => {
          const kino = this.kinoList.find((k) => {
            return d.mstKinoId === k.id
          })
          d.kinoNm = kino.kinoNm
          d.viewNm = kino.viewNm
          return d
        }).sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
        return m
      })
        .sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
      return result
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msysmenudetail', 'msyskino'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstKengenList.defineHeaderPromise')
            var headerList = []
            var headerData = {}
            self.filteredMenuList.forEach(function (item) {
              item.listDisplay.forEach(function (itemLists) {
                headerData = {}
                headerData.text = itemLists.kinoNm
                headerData.value = 'key_' + itemLists.mstKinoId
                headerList.push(headerData)
              })
            })
            headerData = {}
            headerData.text = '表示順'
            headerData.value = 'hyojiOrderDisp'
            headerData.align = 'end'
            headerList.push(headerData)
            headerData = {}
            headerData.text = '権限グループ名称'
            headerData.value = 'kengenGroupNm'
            headerList.unshift(headerData)
            headerData = {}
            headerData.text = '権限グループコード'
            headerData.value = 'kengenGroupCd'
            headerList.unshift(headerData)
            headerData = {}
            headerData.text = '編集'
            headerData.value = 'actions'
            headerData.sortable = false
            headerData.width = '20px'
            headerList.unshift(headerData)

            self.headers = headerList
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              kengenGroupCd: '',
              kengenGroupNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstKengenList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstKengenList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstKengenList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstKengenList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstKengenList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstKengenGroup/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              kengenGroupCd: '',
              kengenGroupNm: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCMstKengenGroup/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
